/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClockInPinLoginRequest
 */
export interface ClockInPinLoginRequest {
    /**
     * 
     * @type {string}
     * @memberof ClockInPinLoginRequest
     */
    clockInPin: string;
}

/**
 * Check if a given object implements the ClockInPinLoginRequest interface.
 */
export function instanceOfClockInPinLoginRequest(value: object): value is ClockInPinLoginRequest {
    if (!('clockInPin' in value) || value['clockInPin'] === undefined) return false;
    return true;
}

export function ClockInPinLoginRequestFromJSON(json: any): ClockInPinLoginRequest {
    return ClockInPinLoginRequestFromJSONTyped(json, false);
}

export function ClockInPinLoginRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClockInPinLoginRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'clockInPin': json['clockInPin'],
    };
}

  export function ClockInPinLoginRequestToJSON(json: any): ClockInPinLoginRequest {
      return ClockInPinLoginRequestToJSONTyped(json, false);
  }

  export function ClockInPinLoginRequestToJSONTyped(value?: ClockInPinLoginRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'clockInPin': value['clockInPin'],
    };
}

